import Entity from '../../../core/domain/entity';
import UniqueEntityID from '../../../core/domain/unique_entity_id';

export type MediaType =
  | 'image'
  | 'video'
  | 'document'
  | 'zoom'
  | 'external'
  | 'stripe'
  | 'replay';
export type ResourceStatus = 'active' | 'inactive';
export type ResourceCategory =
  | 'news'
  | 'masterclass'
  | 'tutorial'
  | 'support'
  | 'classroom'
  | 'metaphor'
  | 'promo';
export interface Picture {
  url: string;
  path: string;
  mimeType: string;
  createdAt?: Date | undefined;
}

export interface ResourceProps {
  title?: string | undefined;
  picture?: Picture | undefined;
  date?: Date | undefined;
  content: string;
  credits?: string | undefined;
  mediaUrl?: string | undefined;
  mediaType: MediaType;
  status: ResourceStatus;
  category: ResourceCategory;
  createdAt: Date;
  updatedAt: Date | undefined;
}

export class ResourceId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): ResourceId {
    return new ResourceId(id);
  }
}

export class Resource extends Entity<ResourceProps> {
  get resourceId(): ResourceId {
    return ResourceId.create(this.id);
  }

  get title(): string | undefined {
    return this.props.title;
  }

  set title(value: string | undefined) {
    this.props.title = value;
  }

  get picture(): Picture | undefined {
    return this.props.picture;
  }

  set picture(value: Picture | undefined) {
    this.props.picture = value;
  }

  get date(): Date | undefined {
    return this.props.date;
  }

  set date(value: Date | undefined) {
    this.props.date = value;
  }

  get content(): string {
    return this.props.content;
  }

  set content(value: string) {
    this.props.content = value;
  }

  get credits(): string | undefined {
    return this.props.credits;
  }

  set credits(value: string | undefined) {
    this.props.credits = value;
  }

  get mediaType(): MediaType {
    return this.props.mediaType;
  }

  set mediaType(value: MediaType) {
    this.props.mediaType = value;
  }

  get mediaUrl(): string | undefined {
    return this.props.mediaUrl;
  }

  set mediaUrl(value: string | undefined) {
    this.props.mediaUrl = value;
  }

  get status(): ResourceStatus {
    return this.props.status;
  }

  set status(value: ResourceStatus) {
    this.props.status = value;
  }

  get category(): ResourceCategory {
    return this.props.category;
  }

  set category(value: ResourceCategory) {
    this.props.category = value;
  }

  get createdAt(): Date {
    return this.props.createdAt;
  }

  get updatedAt(): Date | undefined {
    return this.props.updatedAt;
  }

  copyWith(props: ResourceProps): Resource {
    return Resource.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  private constructor(props: ResourceProps, id?: UniqueEntityID) {
    super(props, id);
  }

  public static create(props: ResourceProps, id?: UniqueEntityID): Resource {
    return new Resource(props, id);
  }
}
